import { render, staticRenderFns } from "./PdvCategoriasDrawer.vue?vue&type=template&id=7f6863b6&scoped=true&"
import script from "./PdvCategoriasDrawer.vue?vue&type=script&setup=true&lang=js&"
export * from "./PdvCategoriasDrawer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6863b6",
  null
  
)

export default component.exports